import * as React from 'react';
import { cn } from '@/lib/utils';

interface SovCardProps extends React.HTMLAttributes<HTMLDivElement> {
  variant?: 'default' | 'glass' | 'gradient' | 'glow' | 'subtle';
  padding?: 'none' | 'sm' | 'md' | 'lg';
  hover?: boolean;
}

const paddingMap = { none: '', sm: 'p-4', md: 'p-6', lg: 'p-8' };
const variantMap = {
  default:  'bg-zinc-900 border border-zinc-800',
  glass:    'bg-zinc-900/50 backdrop-blur-lg border border-zinc-800',
  gradient: 'bg-gradient-to-br from-zinc-900 via-zinc-800 to-zinc-900',
  glow:     'bg-zinc-900 border border-brand/30 shadow-lg shadow-brand/10',
  subtle:   'bg-zinc-900 border border-zinc-800',
};

export function SovCard({ className, variant = 'default', padding = 'md', hover = false, ...props }: SovCardProps) {
  return (
    <div
      className={cn(
        'rounded-xl transition-all duration-200',
        variantMap[variant],
        paddingMap[padding],
        hover && 'hover:border-brand/50 hover:shadow-lg hover:shadow-brand/5 cursor-pointer',
        className
      )}
      {...props}
    />
  );
}

export function SovCardTitle({ className, ...props }: React.HTMLAttributes<HTMLHeadingElement>) {
  return <h3 className={cn('text-xl font-bold text-slate-50', className)} {...props} />;
}

export function SovCardDescription({ className, ...props }: React.HTMLAttributes<HTMLParagraphElement>) {
  return <p className={cn('text-sm text-slate-400', className)} {...props} />;
}
